<template>
	<div>
		<!-- 去认证 -->
		<div style="width: 0.4rem;height: 0.4rem;margin: 0 auto">
			<img style="100%;height: 100%;" src="@/assets/img/tips／exclamation-circle-fill@2x.png" />
		</div>
		
		<div style="text-align: center;font-size: 0.16rem;margin: 0.16rem 0;">您还未进行实名认证，实名认证后才可添加银行卡</div>
		<div style="display: flex;justify-content: center;">
			<div class="dataBtnSubmit">去认证</div>
		</div>
	</div>
</template>

<script>
</script>
<style scoped>
	@import url(/src/assets/css/com.css);
</style>